// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { DocumentGroupSource } from './documentGroupSource.js';
import type { DocumentGroupStatus } from './documentGroupStatus.js';
import type { DocumentPdfFileModel } from './documentPdfFileModel.js';
import type { DocumentStatus } from './documentStatus.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class DocumentPdfDocumentModel {
    'templateData'?: DocumentPdfFileModel | null;
    'documentTypeId'?: number;
    'documentStatus'?: DocumentStatus;
    'documentGroupStatus'?: DocumentGroupStatus;
    'documentGroupSource'?: DocumentGroupSource;
    'documentGroupReceivedDate'?: Moment;
    'documentOriginalFileName'?: string;
    'documentPageCount'?: number;
    'faxAni'?: string;
    'faxDns'?: string;
    'intakeLayoutId'?: number;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof DocumentPdfDocumentModel>> = [
        {
            "name":     "templateData",
            "baseName": "templateData",
            "type":     "DocumentPdfFileModel"
        },
        {
            "name":     "documentTypeId",
            "baseName": "documentTypeId",
            "type":     "number"
        },
        {
            "name":     "documentStatus",
            "baseName": "documentStatus",
            "type":     "DocumentStatus"
        },
        {
            "name":     "documentGroupStatus",
            "baseName": "documentGroupStatus",
            "type":     "DocumentGroupStatus"
        },
        {
            "name":     "documentGroupSource",
            "baseName": "documentGroupSource",
            "type":     "DocumentGroupSource"
        },
        {
            "name":     "documentGroupReceivedDate",
            "baseName": "documentGroupReceivedDate",
            "type":     "Date"
        },
        {
            "name":     "documentOriginalFileName",
            "baseName": "documentOriginalFileName",
            "type":     "string"
        },
        {
            "name":     "documentPageCount",
            "baseName": "documentPageCount",
            "type":     "number"
        },
        {
            "name":     "faxAni",
            "baseName": "faxAni",
            "type":     "string"
        },
        {
            "name":     "faxDns",
            "baseName": "faxDns",
            "type":     "string"
        },
        {
            "name":     "intakeLayoutId",
            "baseName": "intakeLayoutId",
            "type":     "number"
        },
    ];

    static getAttributeTypeMap() {
        return DocumentPdfDocumentModel.attributeTypeMap;
    }
}
